.global-variables {
  /*Default text colors*/
  --dds-color-text-body: var(--dds-color-text-default);
  --dds-color-text-body-subtle: var(--dds-color-text-subtle);
  --dds-color-text-link: var(--dds-color-text-action-resting);
  --dds-color-text-link-visited: var(--dds-color-text-action-visited);
  --dds-color-text-label: var(--dds-color-text-medium);
  --dds-color-text-placeholder: var(--dds-color-text-subtle);
  --dds-color-text-helper: var(--dds-color-text-subtle);
  --dds-color-icon-link: var(--dds-color-text-action-resting);
  /*Inversable text colors*/
  --dds-color-text-subtle-inversable: var(--dds-color-text-subtle);
  --dds-color-text-default-inversable: var(--dds-color-text-default);
  --dds-color-text-medium-inversable: var(--dds-color-text-medium);
  --dds-color-text-action-resting-inversable: var(
    --dds-color-text-action-resting
  );
  --dds-color-text-action-hover-inversable: var(--dds-color-text-action-hover);
  --dds-color-text-requiredfield-inversable: var(
    --dds-color-text-requiredfield
  );
  --dds-color-icon-subtle-inversable: var(--dds-color-icon-subtle);
  --dds-color-icon-default-inversable: var(--dds-color-icon-default);
  --dds-color-icon-medium-inversable: var(--dds-color-icon-medium);
  --dds-color-icon-action-resting-inversable: var(
    --dds-color-icon-action-resting
  );
  --dds-color-icon-action-hover-inversable: var(--dds-color-icon-action-hover);

  /*Focus*/
  --dds-focus-outline: var(--dds-color-focus-outside) 2px solid;
  --dds-focus-outline-offset: var(--dds-spacing-x0-125);
  --dds-focus-outline-inset: calc(0px - var(--dds-spacing-x0-25));
  --dds-focus-box-shadow: 0 0 0 2px var(--dds-color-focus-inside);
  --dds-focus-transition: outline-offset var(--dds-motion-surface);

  /*Sizes*/
  --dds-input-default-width: 320px;
  --dds-input-default-width-xsmall: 210px;
  --dds-spacing-xs-icon-text-gap: var(--dds-spacing-x0-25);
  --dds-spacing-sm-icon-text-gap: var(--dds-spacing-x0-25);
  --dds-spacing-md-icon-text-gap: var(--dds-spacing-x0-5);
  --dds-spacing-lg-icon-text-gap: var(--dds-spacing-x0-75);
}

.global-styles {
  font: var(--dds-font-body-long-medium);
  letter-spacing: var(--dds-font-body-long-medium-letter-spacing);
  color: var(--dds-color-text-default);
}
